import { collectionRef } from "./firebase";
import {CONFIG_COLLECTION, CONFIG_IM_TIME, CONFIG_WORKDAY} from '../config/CONSTANTS'
import { convertStringToObject, getParamValue } from "utils/rcUtils";

export const onUpdateRemoteConfig = (callback) => {
  return collectionRef(CONFIG_COLLECTION)
    .doc(CONFIG_IM_TIME)
    .onSnapshot(async (snapshot) => {
      console.log("Remote Config", snapshot.data())
      if (snapshot.exists) {
        await callback(snapshot.data());
      }
    });
};

/**
 * Load sign_info from Remote Config (Firestore config/imTime → imWarehouse group).
 * Same source as useRemoteConfig("sign_info", "imWarehouse").
 * @return {Promise<{ sign_key?: string, sign_skew_ms?: string }>}
 */
export const getSignInfoFromRc = async () => {
  try {
    const snapshot = await collectionRef(CONFIG_COLLECTION)
      .doc(CONFIG_IM_TIME)
      .get();
    if (!snapshot.exists) {
      console.log("Error in rconfig > getSignInfoFromRc= config/imTime missing");
      return {};
    }
    const raw = getParamValue(
      snapshot.data()?.config,
      "sign_info",
      "imWarehouse"
    );
    const result = convertStringToObject(raw || "{}");
    console.log("RC result for getSignInfoFromRc=", result);
    return result && typeof result === "object" ? result : {};
  } catch (err) {
    console.log("Error in rconfig > getSignInfoFromRc=", err);
    return {};
  }
};

export const getWorkdayConfigDetails = async () => {
  console.log("services > rcConfig > getWorkdayConfigDetails called...");
  return new Promise(async (res, rej) => {
    try {
      const snapshot = await collectionRef(CONFIG_COLLECTION)
        .doc(CONFIG_WORKDAY)
        .get();
      console.log(
        "in services > rcConfig > getWorkdayConfigDetails [SUCCESS]"
      );
      res(snapshot.data() || {});
    } catch (error) {
      console.error(
        "in services > rcConfig > getWorkdayConfigDetails, err===" + error
      );
      rej(error);
    }
  });
};
